import { z } from 'zod';
import { RoleSchema } from './roles.js';
export const LoginInputSchema = z.object({
    email: z.string().email('Invalid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const UserPublicSchema = z.object({
    id: z.number(),
    email: z.string().email(),
    name: z.string(),
    role: RoleSchema,
    active: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=auth.js.map